import {Badge} from "@/instantsearch/components/Badge";
import {useTranslations} from "@/hooks/useTranslations";
import { useStats, type UseStatsProps} from "react-instantsearch";

export function Stats(props: UseStatsProps) {
    const {nbHits} = useStats(props);
    const tc = useTranslations();
    if (!(nbHits > 0)) return;
    return (
       <div className={"ais-stats"} role="status">
          <span className={"ais-stats__root"} aria-hidden={true}>
			  <Badge value={nbHits}/>{tc.results}
		  </span>
		   <span className={"sr-only"}>{nbHits + " " + tc.results}</span>
       </div>
    );
}
